'use strict'

angular
  .module('basalteApp')
  .constant('BAS_CONNECTED_DEVICES', {
    EVT_BAS_CONNECTED_DEVICES_UPDATED: 'evtBasConnectedDevicesUpdated',
    EVT_BAS_SERVERS_UPDATED: 'evtBasServersUpdated',
    EVT_BAS_SERVERS_UPDATE_STATE: 'evtBasServersUpdateState'
  })
